import { Directive, ElementRef, Input, HostListener, Output, EventEmitter, Renderer2, OnInit } from '@angular/core';
import { EventService } from '../services/event-service';

@Directive({
	selector: '[fileDroppable]'
})

export class FileDroppableDirective implements OnInit {
	@Input() hoverClass = 'file-hovering';
	@Input() elementHoverClass = 'element-hovering';
	@Input() windowHoverClass = 'file-hovering-window';
	@Output() onFilesDropped: EventEmitter<FileList> = new EventEmitter<FileList>();
	@Output() onDropEvent: EventEmitter<Event> = new EventEmitter<Event>();
	dragOverListener: any;

	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		private eventService: EventService
	) {
	}

	@HostListener('dragenter', ['$event'])
	onDragEnter(ev: Event) {
		if (!this.el.nativeElement.classList.contains(this.hoverClass)) {
			this.el.nativeElement.classList.add(this.hoverClass);
			this.el.nativeElement.classList.remove(this.windowHoverClass);

			this.dragOverListener = this.renderer.listen(this.el.nativeElement, 'dragover', (dev: DragEvent) => {
				dev.preventDefault();
			});
		}
	}

	@HostListener('dragleave', ['$event'])
	onDragLeave(ev: Event) {
		if (this.el.nativeElement.classList.contains(this.hoverClass)) {
			this.el.nativeElement.classList.remove(this.hoverClass);
			if (this.dragOverListener) {
				this.dragOverListener();
				this.dragOverListener = null;
			}
		}
	}

	@HostListener('drop', ['$event'])
	onDrop(evt: Event) {
		// DragEvent isn't available on ios safari...
		const ev = evt as any;
		if (ev && ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files.length) {
			this.onFilesDropped.emit(ev.dataTransfer.files);
			this.onDropEvent.emit(evt);
		}
		this.dragStopped();
		ev.preventDefault();
	}

	ngOnInit() {
		this.eventService.documentFileDragging.subscribe((isDragging) => {
			if (isDragging) {
				if (!this.el.nativeElement.classList.contains(this.windowHoverClass)) {
					this.el.nativeElement.classList.add(this.windowHoverClass);
				}
			} else {
				this.el.nativeElement.classList.remove(this.windowHoverClass);
			}
		});
	}

	dragStopped() {
		this.el.nativeElement.classList.remove(this.hoverClass);
		this.el.nativeElement.classList.remove(this.windowHoverClass);

		if (this.dragOverListener) {
			this.dragOverListener();
			this.dragOverListener = null;
		}
	}
}
